const normalizeDomainName = (hostname) => {
  const domainName = hostname || ""

  if (domainName === "gratipos-a4b23") {
    return "dev"
  }
  if (hostname === "dev.vienvu.com") {
    return "dev.gratisoft.tech"
  }
  return domainName
}

export const getDomainNameHeaderValue = () => {
  if (typeof window === "undefined") {
    return ""
  }

  let domain = window.location.hostname
  if (
    domain === "localhost" ||
    domain === "dev.vienvu.com" ||
    domain === "127.0.0.1"
  ) {
    domain = "dev.gratisoft.tech"
  }
  if (domain == "app.vienvu.com") {
    domain = "app.le-aesthetic.vn"
  }
  if (domain == "we.vienvu.com") {
    domain = "we.worldexport.com.vn"
  }

  return normalizeDomainName(domain)
}
